import React from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import aboutbg from './../../images/aboutus-bg-2.png';

export const AboutScreen = () => {
  const { t } = useTranslation(); // Hook for translations

  return (
    <div className="min-h-svh">
      {/* Full-Width About Section */}
      <section
        className="w-full md:h-[700px] flex flex-col justify-center text-black px-smallPx md:px-mediumPx lg:px-[250px] pt-10 bg-cover bg-center rounded-lg"
        style={{
          backgroundImage: `url(${aboutbg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
        }}
      >
        <div className="w-full py-10">
          <h1 className="text-4xl font-bold mb-4 text-white">
            {t('aboutScreen.title')}
          </h1>
          <p className="text-[14px] text-white">
            {t('aboutScreen.description1', {
              company: 'Sonnen Raffstoren',
            })}{' '}
            <strong>{t('aboutScreen.strong1')}</strong>{' '}
            {t('aboutScreen.descriptionMiddle')}{' '}
            <strong>{t('aboutScreen.strong2')}</strong>{' '}
            {t('aboutScreen.description2')}
          </p>
        </div>
        <div className="flex w-full items-center justify-center py-10">
          <div className="flex flex-col md:flex-row bg-white/70 backdrop-blur p-10 gap-5 rounded-[5px] shadow-xl">
            <div className="flex flex-col items-center justify-center">
              <h1 className="text-[36px] font-[800]">100%</h1>
              <p className="text-[14px] font-[400]">
                {t('aboutScreen.stats.customerSatisfaction')}
              </p>
            </div>

            {/* Vertical separator */}
            <div className="hidden md:block h-24 w-px bg-black" />
            <hr className="block md:hidden w-full h-[0.5px] border-black" />

            <div className="flex flex-col items-center justify-center">
              <h1 className="text-[36px] font-[800]">95%</h1>
              <p className="text-[14px] font-[400]">
                {t('aboutScreen.stats.energyEfficiency')}
              </p>
            </div>

            {/* Vertical separator */}
            <div className="hidden md:block h-24 w-px bg-black" />
            <hr className="block md:hidden w-full h-[0.5px] border-black" />

            <div className="flex flex-col items-center justify-center">
              <h1 className="text-[36px] font-[800]">+10 000</h1>
              <p className="text-[14px] font-[400]">
                {t('aboutScreen.stats.blindsInstalled')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="px-smallPx md:px-mediumPx lg:px-[250px] py-[40px]">
        <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left column with text content */}
          <div>
            <h2 className="text-3xl font-bold mb-4">
              {t('aboutScreen.commitmentTitle')}
            </h2>
            <p className="text-gray-700 text-[14px]">
              {t('aboutScreen.commitmentDescription')}
            </p>
          </div>

          {/* Right column with list content */}
          <div>
            <h2 className="text-3xl font-bold mb-4">
              {t('aboutScreen.whyChooseTitle')}
            </h2>
            <ul className="list-disc ml-5 text-gray-700 text-[14px]">
              <li className="m-0">
                {t('aboutScreen.whyChooseList.innovativeDesigns')}
              </li>
              <li className="m-0">
                {t('aboutScreen.whyChooseList.customBlinds')}
              </li>
              <li className="m-0">
                {t('aboutScreen.whyChooseList.aestheticsEnergy')}
              </li>
              <li className="m-0">
                {t('aboutScreen.whyChooseList.expertConsultation')}
              </li>
              <li className="m-0">
                {t('aboutScreen.whyChooseList.reliableSupport')}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutScreen;
